import { create } from "zustand";
import {toast} from "react-toastify";
import { useI18nStore } from "./i18n.store";

const defaultSelectedColumns = [
  "opportunity_id",
  "description",
  "create_date",
  "end_customer",
  "current_state",
  "purchase_total_amount_local_currency",
];

export const useOpportunitiesTableStore = create((set, get) => {
  return {
    selectedColumns: [...defaultSelectedColumns],
    getAvailableColumns: () => {
      const t = useI18nStore.getState().t;
      return {
        opportunity_id: t("opportunities.id"),
        description: t("common.description"),
        end_customer: t("opportunities.endCustomer"),
        create_date: t("opportunities.created"),
        invoice_date: t("opportunities.invoiced"),
        sales_person: t("opportunities.salesperson"),
        exn_person: "Excl. osoba",
        current_state: t("common.state"),
        purchase_total_amount_local_currency: t("opportunities.amount"),
      };
    },
    toggleColumn: (key) => {
      const t = useI18nStore.getState().t;
      if (!get().selectedColumns.includes(key)) {
        if (get().selectedColumns.length >= 7) {
          toast.error(t("users.cannotSelectMoreColumns"));
          return;
        }
      }

      set((state) => ({
        selectedColumns: state.selectedColumns.includes(key)
            ? state.selectedColumns.filter((col) => col !== key)
            : [...state.selectedColumns, key],
      }))
    },
  };
});
